import { render, staticRenderFns } from "./alert_feedback_controls.vue?vue&type=template&id=5a1d147b&scoped=true&"
import script from "./alert_feedback_controls.vue?vue&type=script&lang=js&"
export * from "./alert_feedback_controls.vue?vue&type=script&lang=js&"
import style0 from "./alert_feedback_controls.vue?vue&type=style&index=0&id=5a1d147b&scoped=true&lang=css&"
import style1 from "./alert_feedback_controls.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1d147b",
  null
  
)

export default component.exports